import baseSetToString from "./component-library496.mjs";
import shortOut from "./component-library497.mjs";
var setToString = shortOut(baseSetToString);
const setToString$1 = setToString;
export {
  setToString$1 as default
};
